import { createSelector } from 'reselect'

import { isAvailableFeatureSelector } from 'features/billing'

const featureRootSelector = ({ routingFormsEditPage }) => routingFormsEditPage

export const editedFieldSelector = createSelector(
  featureRootSelector,
  ({ editedField }) => editedField
)

export const editingButtonSelector = createSelector(
  featureRootSelector,
  ({ editingButton }) => editingButton
)

export const isPublishFormPopupOpenSelector = createSelector(
  featureRootSelector,
  ({ isPublishFormPopupOpen }) => isPublishFormPopupOpen
)

export const isPermissionsPopupOpenSelector = createSelector(
  featureRootSelector,
  ({ isPermissionsPopupOpen }) => isPermissionsPopupOpen
)

export const isExternalFormPopupOpenSelector = createSelector(
  featureRootSelector,
  ({ isExternalFormPopupOpen }) => isExternalFormPopupOpen
)

export const isPreviewOpenSelector = createSelector(
  featureRootSelector,
  ({ isPreviewOpen }) => isPreviewOpen
)

export const currentRouteSelector = createSelector(
  featureRootSelector,
  ({ route }) => route
)

export const deletingRouteSelector = createSelector(
  featureRootSelector,
  ({ deletingRoute }) => deletingRoute
)

export const isNewFormPopupOpenSelector = createSelector(
  featureRootSelector,
  ({ isNewFormPopupOpen }) => isNewFormPopupOpen
)

export const businessUnitIdSelector = createSelector(
  featureRootSelector,
  ({ businessUnitId }) => businessUnitId
)

export const externalObjectNameSelector = createSelector(
  featureRootSelector,
  ({ externalObjectName }) => externalObjectName
)

export const isAvailableSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'routing_forms' }
)

export const isExternalFormsAvailableSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'external_forms' }
)

export const isSalesforceRoutingAvailableSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'salesforce_routing' }
)

export const isHubspotRoutingAvailableSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'hubspot_routing' }
)

export const isTeamsHubspotRoutingAvailableSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'team_hubspot_routing' }
)
